/**
 * How a card is named to the client: the last four digits, masked.
 *
 * Payoma hands back the number already masked — "5303 26** **** 9929" —
 * and the last four are real. Printed whole it is a mouthful that pushes
 * everything beside it off the row; those four digits are the only part
 * that tells one card from another.
 *
 * The same shape is used on the Dashboard tiles and in the top-up picker,
 * which each worked it out their own way. This is that, in one place.
 */

/** "5303 26** **** 9929" → "9929"; null when there is nothing to take. */
export const cardLastFour = (number: string | null | undefined): string | null => {
  const digits = String(number ?? '').replace(/\D/g, '');
  return digits.length >= 4 ? digits.slice(-4) : null;
};

/** "5303 26** **** 9929" → "**** 9929"; null when the number is unusable. */
export const maskedCardNumber = (number: string | null | undefined): string | null => {
  const lastFour = cardLastFour(number);
  return lastFour ? `**** ${lastFour}` : null;
};
